import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {map} from 'rxjs/operators';
import {Observable} from 'rxjs';
import {environment} from '../../../environments/environment';
import {ImportCsvResponseDto} from '../../dtos/importCsvResponse.dto';

@Injectable({
    providedIn: 'root'
})
export class ParticipantAdminService {

    constructor(private httpClient: HttpClient) {
    }

    public importCsvPatients(userCode: string, file: File, tagName?: string, tagColor?: string): Observable<ImportCsvResponseDto> {
        const url = environment.apiUrl + 'api/participants/admin/v1/importCsv';

        let params = new HttpParams().set('userCode', userCode || '');

        if (tagName && tagName.trim() !== '') {
            params = params.set('tagName', tagName.trim());
        }
        if (tagColor && tagColor.trim() !== '') {
            // HttpParams will percent-encode the value (so '#' becomes '%23')
            params = params.set('tagColor', tagColor.trim());
        }

        const form = new FormData();
        form.append('file', file, file.name);

        return this.httpClient.post<any>(url, form, { params })
            .pipe(map(resp => new ImportCsvResponseDto().deserialize(resp)));
    }
}
